/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * @module bulb-image/bulb-imagecrop
 */
import { Plugin } from 'ckeditor5';
import BulbImageCropUI from './bulbimagecropui';
import BulbImageCropToolbar from './bulbimagecroptoolbar';

/**
 * The glue image-crop plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbImageCrop extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbImageCropUI, BulbImageCropToolbar] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName(): string {
    return 'BulbImageCrop' as const;
  }
}
